import React, { Component } from 'react';
import './pages.css';

import Button from './button.js';

require('./Fonts/691970/0a9b9cc6-55eb-4369-97ed-87b3eefd433a.woff2');
require('./Fonts/691979/84e1d9b2-4a5e-42f7-b7bb-e9edadb46977.woff2');


const image1 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522653/graphic/g1_jkt6li.png';
const image2 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g2_zouctm.jpg';
const image3 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522653/graphic/g3_un7uya.jpg';
const image4 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g4_kmvcax.jpg';
const image5 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522653/graphic/g5_nntqcq.jpg';
const image6 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g6_xt5prc.jpg';
const image7 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g7_oyiogh.jpg';
const image8 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g8_cvvn0s.jpg';
const image9 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g9_k53q2f.jpg';
const image11 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g11_ndh8ma.jpg';
const image10 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g10_ohjlmc.jpg';
const image12 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g12_jdw4t8.jpg';
const image13 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g13_us7oda.jpg';
const image14 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g14_a5ymrw.jpg';
const image15 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522654/graphic/g15_flzww9.jpg';
const image16 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522655/graphic/g16_bqagyt.jpg';

const allExpandableImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
];

let nextImage, prevImage, clearImage;

const handleKeyDown = (e) => {
    const key = e.keyCode;
    const escape = 27;
    const leftArrow = 37;
    const rightArrow = 39;

    if (key === escape) {
        clearImage && clearImage();
        e.stopPropagation();
        e.preventDefault();
    } else if (key === rightArrow) {
        nextImage && nextImage();
        e.stopPropagation();
        e.preventDefault();
    } else if (key === leftArrow) {
        prevImage && prevImage();
        e.stopPropagation();
        e.preventDefault();
    }
};

class GraphicPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
        imageToShow: undefined
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', handleKeyDown);
  }

  render() {
    const { changePage } = this.props;
    const { imageToShow } = this.state;
    const setImage = (image) => {
        this.setState({ imageToShow: image });
    };

    nextImage = () => {
        if (!!imageToShow) {
            const index = allExpandableImages.indexOf(imageToShow);
            setImage(allExpandableImages[(index + 1) % allExpandableImages.length]);
        }
    };

    prevImage = () => {
        if (!!imageToShow) {
            const index = allExpandableImages.indexOf(imageToShow);
            setImage(allExpandableImages[(index + allExpandableImages.length - 1) % allExpandableImages.length]);
        }
    };

    clearImage = () => setImage(undefined);

    return (
      <div>
        <div className={"modal-" + !!imageToShow}>
            <div className="backdrop" onClick={() => setImage(undefined)}></div>
            <img className="image-displayer" src={imageToShow} />
        </div>
        <div className="maincontent">
            <div className="header-bar-small">
                <div className="name-title light">
                    <h1 onClick={() => changePage("main")}>Christina Winchester</h1>
                </div>
                <div className="button-bar-small">
                    <Button changePage={changePage} pageName="character" innerClassName="btn-smaller" containerClassName="character-btn-container" buttonFile={require('./images/buttonc.svg')} caption="Character Design"/>
                    <Button changePage={changePage} pageName="animation" innerClassName="btn-small" containerClassName="animation-btn-container" buttonFile={require('./images/buttona.svg')} caption="Animation"/>
                    <Button changePage={changePage} pageName="graphic" innerClassName="btn-small" containerClassName="graphic-btn-container" buttonFile={require('./images/buttong.svg')} caption="Graphic Design"/>
                    <Button changePage={changePage} pageName="uxui" innerClassName="btn-smaller" containerClassName="uxui-btn-container" buttonFile={require('./images/buttonu.svg')} caption="UX/UI Design"/>
                </div>
            </div>
            <div className="heading-right darker">
                <h1>Graphic Design</h1>
            </div>
            <div className="heading-bar-right">
                <img src={require('./images/graphic/bg2.jpg')}/>
            </div>
            <div className="centered-narrow medium graphic-description">
                With over 4 years of experience in the field, it's safe to say that I know my way with graphic design. For anything from logo development to website creation, I can make your product look fantastic!
            </div>
            <div className="products-section centered-full">
                <div className="products-section-left-pane">
                    <div className="products-heading light">
                        <h2>Products &amp; Branding</h2>
                    </div>
                    <div>
                        <img className="graphic-btn-1 clickable" src={require('./images/graphic/buttons/gb1.png')} onClick={() => setImage(image1)} />
                    </div>
                </div>
                <div className="products-section-right-pane">
                    <div>
                        <img className="graphic-btn-2 clickable" src={require('./images/graphic/buttons/gb2.png')} onClick={() => setImage(image2)} />
                    </div>
                    <div className="products-section-btn-bar">
                        <img className="graphic-btn-3 clickable" src={require('./images/graphic/buttons/gb3.png')} onClick={() => setImage(image3)} />
                        <img className="graphic-btn-4 clickable" src={require('./images/graphic/buttons/gb4.png')} onClick={() => setImage(image4)} />
                        <img className="graphic-btn-5 clickable" src={require('./images/graphic/buttons/gb5.png')} onClick={() => setImage(image5)} />
                        <img className="graphic-btn-6 clickable" src={require('./images/graphic/buttons/gb6.png')} onClick={() => setImage(image6)} />
                    </div>
                </div>
            </div>
            <div className="logo-design-section">
                <div className="logo-design-section-header light">
                    <h2>Logo Design</h2>
                </div>
                <div className="logos">
                    <div className="logopair">
                        <img className="clickable" src={require('./images/graphic/buttons/gb7.png')} onClick={() => setImage(image7)} />
                        <img className="clickable" src={require('./images/graphic/buttons/gb12.png')} onClick={() => setImage(image12)} />
                    </div>
                    <div className="logopair">
                        <img className="clickable" src={require('./images/graphic/buttons/gb8.png')} onClick={() => setImage(image8)} />
                        <img className="clickable" src={require('./images/graphic/buttons/gb13.png')} onClick={() => setImage(image13)} />
                    </div>
                    <div className="logopair">
                        <img className="clickable" src={require('./images/graphic/buttons/gb9.png')} onClick={() => setImage(image9)} />
                        <img className="clickable" src={require('./images/graphic/buttons/gb14.png')} onClick={() => setImage(image14)} />
                    </div>
                    <div className="logopair">
                        <img className="clickable" src={require('./images/graphic/buttons/gb10.png')} onClick={() => setImage(image10)} />
                        <img className="clickable" src={require('./images/graphic/buttons/gb15.png')} onClick={() => setImage(image15)} />
                    </div>
                    <div className="logopair">
                        <img className="clickable" src={require('./images/graphic/buttons/gb11.png')} onClick={() => setImage(image11)} />
                        <img className="clickable" src={require('./images/graphic/buttons/gb16.png')} onClick={() => setImage(image16)} />
                    </div>
                </div>
            </div>
            <img src={require('./images/animation/ba4.jpg')} />
            <div className="copyright-info">
                © Christina Winchester; 2019
            </div>
        </div>
      </div>
    );
  }
}

export default GraphicPage;
